import React from 'react'

export default function Footer() {
  return (
    <div className="footer">
      <div>Copyright @ 2017 Macho Architectz</div>
      <div className='footer-text'>Designed and developed by <span className="my-link"><a href="http://www.machoarchitectz.in">MACHO</a></span></div>
    </div>
  )
}
